import styled from '@emotion/styled'
import Box from '@mui/material/Box'

import { useShowScrollToTopButton } from 'utils/hooks'
import ResponsiveDiv from 'components/common/ResponsiveDiv'
import ScrollToTopButton from 'components/common/ScrollToTopButton'

const Scrollable = styled.div`
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`

const ScrollableResponsiveDiv = styled(ResponsiveDiv)`
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  height: 100%;
`

const ScrollableWrapper = ({
  children,
  responsive = false,
  onCopy = null,
  containerId = null,
  wrapperRef,
  isAutoScroll = false,
}) => {
  const { showButton, showScrollButton } = useShowScrollToTopButton()
  return responsive ? (
    <ScrollableResponsiveDiv
      onCopy={onCopy}
      ref={wrapperRef}
      onScroll={showScrollButton}
      id={containerId}
    >
      <Box>{children}</Box>
      <ScrollToTopButton
        showButton={showButton}
        scrollableRef={wrapperRef}
        isAutoScroll={isAutoScroll}
      />
    </ScrollableResponsiveDiv>
  ) : (
    <Scrollable
      onCopy={onCopy}
      ref={wrapperRef}
      onScroll={showScrollButton}
      id={containerId}
    >
      <Box>{children}</Box>
      <ScrollToTopButton
        showButton={showButton}
        scrollableRef={wrapperRef}
        isAutoScroll={isAutoScroll}
      />
    </Scrollable>
  )
}

export default ScrollableWrapper
